import { useState } from "react";

const Date = ({ id, label, value, onChange, error, disabled = false,min = false }) => {

    const today = new window.Date().toISOString().split('T')[0];
    const [hoveritem,sethoveritem] = useState(false);
    
  return (
    <div className="custom-date-wrapper">
      <label
        style={{ fontSize: "0.8rem", color: "#2C2B31",padding:'0.1rem 0.3rem' }}
        htmlFor={id}
      >
        {label}
      </label>
      <input
        type="date"
        id={id}
        onFocus={()=>{sethoveritem(!hoveritem)}}
        onBlur={()=>{sethoveritem(!hoveritem)}}
        className="form-control custom-date-input"
        style={{
          fontSize: '0.8rem',
          padding: '0.375rem 11px',
          height: '30px',
          border: error ? '1px solid red' : '',
          backgroundColor: disabled == true ? '#f8f6f6' : 'white',
          cursor:   'text',

        }}
        min={min == true && today}
        value={value}
        onChange={onChange}
        disabled={disabled} 
      />
    </div>
  );
};

export default Date;

